import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { yen } from "@/lib/format";
import { BarChart3, Loader2, Download } from "lucide-react";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from "recharts";

export default function Reports() {
  const [series, setSeries] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/dashboard/cashflow"), api.get("/finance/summary")])
      .then(([c, s]) => { setSeries(c.data); setSummary(s.data); })
      .catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="animate-fade-in">
      <PageHeader
        title="レポート"
        subtitle="経営レポート（年間サマリー）"
        actions={<button className="inline-flex items-center gap-1.5 text-sm border border-border rounded-sm px-3 py-2 hover:bg-gray-50" onClick={() => window.print()} data-testid="report-print"><Download className="w-4 h-4" />印刷 / PDF</button>}
      />
      {loading || !summary ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>
      ) : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-white border border-border rounded-sm p-5"><div className="text-xs text-muted-foreground uppercase mb-1">年間総収入</div><div className="font-display text-2xl text-emerald-600">{yen(summary.income.total)}</div></div>
            <div className="bg-white border border-border rounded-sm p-5"><div className="text-xs text-muted-foreground uppercase mb-1">年間総支出</div><div className="font-display text-2xl text-red-600">{yen(summary.expense.total)}</div></div>
            <div className="bg-white border border-border rounded-sm p-5"><div className="text-xs text-muted-foreground uppercase mb-1">NOI</div><div className="font-display text-2xl text-brand">{yen(summary.noi)}</div></div>
            <div className="bg-white border border-border rounded-sm p-5"><div className="text-xs text-muted-foreground uppercase mb-1">年間CF</div><div className="font-display text-2xl">{yen(summary.cashflow)}</div></div>
          </div>
          <div className="bg-white border border-border rounded-sm p-5">
            <h3 className="text-sm font-medium mb-4 flex items-center gap-2"><BarChart3 className="w-4 h-4 text-brand" />月次 収入 / 支出</h3>
            <ResponsiveContainer width="100%" height={320}>
              <BarChart data={series} margin={{ left: 0, right: 10, top: 4 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eee" vertical={false} />
                <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#999" }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fontSize: 11, fill: "#999" }} axisLine={false} tickLine={false} tickFormatter={(v) => `${Math.round(v / 10000)}万`} />
                <Tooltip formatter={(v) => yen(v)} contentStyle={{ fontSize: 12, borderRadius: 4 }} />
                <Bar dataKey="income" fill="#10B981" name="入金" radius={[2, 2, 0, 0]} />
                <Bar dataKey="expense" fill="#111111" name="支出" radius={[2, 2, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      )}
    </div>
  );
}
